document.addEventListener('cmplz_status_change', function (e) {
    if (e.detail.category === 'marketing' && e.detail.value==='allow') {
        location.reload();
    }
});

document.addEventListener('cmplz_status_change_service', function (e) {
    if ( e.detail.value ) {
        location.reload();
    }
});